import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'bidi-profile-launcher',
  templateUrl: './profile-launcher.component.html',
  styleUrls: ['./profile-launcher.component.scss']
})
export class ProfileLauncherComponent {
  @Output() click = new EventEmitter();

  emit (e: Event) {
    // e.stopPropagation();
    // this.click.emit();
  }
}
